/**
 * Zorunlu şifre değişikliği sayfası: giriş sonrasında kabuk açılmadan önce gösteriliyor,
 * o yüzden popup değil tam sayfa. Form gövdesi popup ile ORTAK.
 */
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { ChangePasswordForm } from './ChangePasswordForm';

export function ChangePasswordPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="flex min-h-dvh items-center justify-center bg-bg px-4">
      <div className="w-full max-w-sm space-y-4 rounded-xl border border-border bg-bg-elevated p-6 shadow-[var(--shadow)]">
        <h1 className="text-lg font-semibold">{t('auth.changePassword.title')}</h1>
        <ChangePasswordForm onSaved={() => navigate('/', { replace: true })} />
      </div>
    </div>
  );
}
